module Omni.ResortMap {
    (function (window, $j) {
    ngModule.directive('resortMapCanvas', (['$rootScope', '$timeout', '$window', '$location', '$state', "Kinetic",
        function ($rootScope, $timeout, $window, $location, $state, Kinetic) {

            function scaleImage(source, scaleFactor) {
                var canvas: any = document.createElement("canvas");
                var ctx: any = canvas.getContext("2d");
                canvas.width = source.width * scaleFactor;
                canvas.height = source.height * scaleFactor;
                ctx.drawImage(source, 0, 0, source.width * scaleFactor, source.height * scaleFactor);
                sharpen(ctx, canvas.width, canvas.height, 0.35);
                return (canvas);
            }

            function sharpen(ctx, w, h, mix) {

                var weights = [0, -1, 0, -1, 5, -1, 0, -1, 0],
                    katet = Math.round(Math.sqrt(weights.length)),
                    half = (katet * 0.5) | 0,
                    dstData = ctx.createImageData(w, h),
                    dstBuff = dstData.data,
                    srcBuff = ctx.getImageData(0, 0, w, h).data,
                    y = h;
                var x;
                while (y--) {
                    x = w;
                    while (x--) {
                        var sy = y,
                            sx = x,
                            dstOff = (y * w + x) * 4,
                            r = 0,
                            g = 0,
                            b = 0,
                            a = 0;
                        for (var cy = 0; cy < katet; cy++) {
                            for (var cx = 0; cx < katet; cx++) {
                                var scy = sy + cy - half;
                                var scx = sx + cx - half;
                                if (scy >= 0 && scy < h && scx >= 0 && scx < w) {
                                    var srcOff = (scy * w + scx) * 4;
                                    var wt = weights[cy * katet + cx];
                                    r += srcBuff[srcOff] * wt;
                                    g += srcBuff[srcOff + 1] * wt;
                                    b += srcBuff[srcOff + 2] * wt;
                                    a += srcBuff[srcOff + 3] * wt;
                                }
                            }
                        }
                        dstBuff[dstOff] = r * mix + srcBuff[dstOff] * (1 - mix);
                        dstBuff[dstOff + 1] = g * mix + srcBuff[dstOff + 1] * (1 - mix);
                        dstBuff[dstOff + 2] = b * mix + srcBuff[dstOff + 2] * (1 - mix)
                        dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
                    }
                }

                ctx.putImageData(dstData, 0, 0);
            }

            function createShape(x, y, shape, id) {
                var r: any = 10;
                var el: any;
                var name: any = 'Marker ' + id;
                var shapeId: any = "shape" + id;

                switch (shape) {
                case "top-left":
                    var sx: any = x;
                    var sy: any = y - r;
                    var ex: any = x - r;
                    var ey: any = y;
                    var ax: any = x - r;
                    var ay: any = y - r;
                    var startPoint: any = "M" + sx + "," + sy;
                    var curve: any = "A" + r + "," + r + ",0,1,1," + ex + "," + ey;
                    var point: any = "L" + ax + "," + ay + "Z";
                    var path: any = startPoint + curve + point;
                    el = new Kinetic.Path({
                        data: path
                    });
                    break;
                case "top-right":
                    var sx: any = x;
                    var sy: any = y - r;
                    var ex: any = x + r;
                    var ey: any = y;
                    var ax: any = x + r;
                    var ay: any = y - r;
                    var startPoint: any = "M" + sx + "," + sy;
                    var curve: any = "A" + r + "," + r + ",0,1,0," + ex + "," + ey;
                    var point: any = "L" + ax + "," + ay + "Z";
                    var path: any = startPoint + curve + point;
                    el = new Kinetic.Path({
                        data: path
                    });
                    break;
                case "bottom-left":
                    var sx: any = x - r;
                    var sy: any = y;
                    var ex: any = x;
                    var ey: any = y + r;
                    var ax: any = x - r;
                    var ay: any = y + r;
                    var startPoint: any = "M" + sx + "," + sy;
                    var curve: any = "A" + r + "," + r + ",0,1,1," + ex + "," + ey;
                    var point: any = "L" + ax + "," + ay + "Z";
                    var path: any = startPoint + curve + point;
                    el = new Kinetic.Path({
                        data: path
                    });
                    break;
                case "bottom-right":
                    var sx: any = x + r;
                    var sy: any = y;
                    var ex: any = x;
                    var ey: any = y + r;
                    var ax: any = x + r;
                    var ay: any = y + r;
                    var startPoint: any = "M" + sx + "," + sy;
                    var curve: any = "A" + r + "," + r + ",0,1,0," + ex + "," + ey;
                    var point: any = "L" + ax + "," + ay + "Z";
                    var path: any = startPoint + curve + point;
                    el = new Kinetic.Path({
                        data: path
                    });
                    break;
                default:
                    el = new Kinetic.Circle({
                        x: x,
                        y: y,
                        radius: r
                    });
                    break;
                }

                el.name(name);
                el.id(shapeId);
                el.fill('#F07230');
                el.stroke('#b14822');
                el.strokeWidth(1);
                el.opacity(1);
                return el;
            }

            function createTextLabel(x, y, posn) {
                var simpleText = new Kinetic.Text({
                    x: x,
                    y: y,
                    text: posn,
                    fontSize: 12,
                    fontStyle: 'italic',
                    fontFamily: 'Calibri',
                    fill: '#ffffff',
                    opacity: 1
                });
                simpleText.offsetX(simpleText.width() / 2);
                simpleText.offsetY(simpleText.height() / 2);

                return simpleText;
            }

            function createMarkerGroup(point, z, xRatio, yRatio) {
                var x = (point.x_coord / 2) * xRatio;
                var y = (point.y_coord / 2) * yRatio;
                var shape = point.marker_type;
                var i = point.id;
                var kids = new Kinetic.Group({
                    id: "group" + i,
                    index: i
                });
                var mapMarker = createShape(x, y, shape, i);
                var label = createTextLabel(x, y, point.posn);

                kids.add(mapMarker);
                kids.add(label);

                return kids;
            }

            function buildPopover(loc, x, y, el) {
                var width = $j("#mapContainer").width();
                var height = $j("#mapContainer").height();

                var popover: any = {};
                var v, h;
                if (y > height / 2) {
                    if (loc.type == "meeting") {
                        var disp = 145;
                    } else {
                        var disp = 100;
                    }
                    if (loc.title.length > 22) {
                        disp = disp + 20;
                    }
                    popover.top = y - disp;
                    v = "top";
                } else {
                    popover.top = y + 20;
                    v = "bottom";
                }

                if (x > width / 2) {
                    h = "l";
                    popover.left = x - 211;
                } else {
                    h = "r";
                    popover.left = x - 20;
                }

                $j("#popoverElement").css({
                    top: popover.top,
                    left: popover.left
                });

                popover.placement = v + ' ' + h;
                popover.title = loc.title;
                popover.type = loc.type;
                popover.el = el;

                return popover;
            }

            function setActiveTabItem(el) {
                // get the type and click the tab
                var type: any = el.type;
                if (type == "leisure") {
                    ($j("#tabs a:first") as any).tab("show");
                } else {
                    ($j("#tabs a:last") as any).tab("show");
                }
                // then click the item
                var li = $j(".locationList").find("[data-list-item='" + el.id + "']");
                li.addClass("active");
            }

            function buildTabPane(el) {
                var html = "";
                html += "<li class=\"listItem\" data-list-item=\"" + el.id + "\">";
                html += "<img src=\"" + el.thumbnail + "\" class=\"locationThumb\" />";
                html += "<span class=\"badge\">" + el.posn + "</span>";
                html += "<h4>" + el.title + "</h4>";
                html += "</li>";

                return html;
            }

            function buildSideBar(data) {
                var html = '';
                html += "<ul id=\"tabs\" class=\"nav nav-tabs nav-justified\">";
                html += "<li class=\"active\"><a class=\"tab-toggle\" data-target=\"#leisure\" data-toggle=\"tab\">Leisure</a></li>";
                html += "<li><a class=\"tab-toggle\" data-target=\"#meeting\" data-toggle=\"tab\">Meeting</a></li>";
                html += "</ul>";
                html += "<div class=\"tab-content\">";

                var leisureHtml = "";
                var meetingHtml = "";

                angular.forEach(data, function (el: any, index) {
                    if (el.type == "leisure") {
                        leisureHtml += buildTabPane(el);
                    } else {
                        meetingHtml += buildTabPane(el);
                    }
                });

                html += "<div class=\"tab-pane active\" id=\"leisure\">";
                html += "<ul class=\"locationList\">" + leisureHtml + "</ul>";
                html += "</div>";
                html += "<div class=\"tab-pane\" id=\"meeting\">";
                html += "<ul class=\"locationList\">" + meetingHtml + "</ul>";
                html += "</div>";
                html += "</div>";

                return html;
            }

            function scrollList() {
                var listContainer = $j(".tab-pane.active");
                var activeListItem = $j(".tab-pane.active ul.locationList li.listItem.active");
                var distance = listContainer.scrollTop() +
                    (activeListItem.position().top - listContainer.position().top)
                    - (listContainer.height() / 2) + (activeListItem.height() / 2);
                listContainer.animate({ scrollTop: distance }, 500, 'swing');
            }


            return {
                restrict: "EA",
                priority: 1001,
                replace: true,
                link: function (scope, element, attrs) {

                    // Build Sidebar List
                    var sidebar = element.find("#mapSidebar");
                    var locations = scope.resort.location;

                    var sideBarHtml = buildSideBar(locations);
                    sidebar.html(sideBarHtml);

                    var regex = new RegExp("[\\?&]m=([^&#]*)"),
                        results: any = regex.exec(location.search);

                    if ((results !== null && results[1] == 1) || $rootScope["activeTab"] == 'meeting' || $j("#topNavLink").text().trim().toLowerCase() == "meetings") {
                        ($j("#tabs a:last") as any).tab("show");
                    }

                    var mainContainer = $j("#mainMapContainer");

                    var containerWidth = mainContainer.width() * (3 / 4);
                    $j("#mapContainer").width(containerWidth);

                    var containerHeight = containerWidth * 430 / 692;
                    $j("#mapContainer").height(containerHeight);
                    $j("#mainMapContainer").height((containerHeight + 1));

                    var xRatio = containerWidth / 692;
                    var yRatio = containerHeight / 430;


                    var map = {
                        parentGroup: null,
                        mapImages: null,
                        canvasId: "mapCanvas",
                        points: locations,
                        fromListClick: false,
                        stage: null,
                        layer: null,
                        popover: null,
                        scale: 1,
                        activeItem: null,
                        targetItem: null,

                        initialize: function (c2) {
                            map.stage = new Kinetic.Stage({
                                container: map.canvasId,
                                width: containerWidth,
                                height: containerHeight
                            });
                            map.layer = new Kinetic.Layer();
                            map.parentGroup = new Kinetic.Group();
                            map.mapImages = new Kinetic.Group();

                            var smResort = new Kinetic.Image({
                                x: 0,
                                y: 0,
                                image: c2,
                                width: Math.round(containerWidth),
                                height: Math.round(containerHeight),
                                listening: true,
                                name: "smallMap"
                            });

                            smResort.on('zoomIn', function (evt) {
                                smResort.opacity(0);
                                lgResort.opacity(1);
                            });

                            var lgResort = new Kinetic.Image({
                                x: 0,
                                y: 0,
                                image: lgImageObj,
                                width: Math.round(containerWidth),
                                height: Math.round(containerHeight),
                                listening: true,
                                name: "largeMap"
                            });

                            lgResort.on('zoomOut', function (evt) {
                                lgResort.opacity(0);
                                smResort.opacity(1);
                            });

                            // add the shape to the layer
                            map.mapImages.add(lgResort);
                            map.mapImages.add(smResort);
                            map.parentGroup.add(map.mapImages);

                            // iterate over points to build marker groups
                            for (var i = 0; i < map.points.length; i++) {
                                // build marker layer - shape, shadow, and text
                                var kids = createMarkerGroup(map.points[i], i, xRatio, yRatio);

                                // add handler to fire tweening function
                                kids.on("tap", function (e) {
                                    var target = (angular.isUndefined(e.target.parent)) ?
                                        e.target : e.target.parent.attrs.index;
                                    $j(".listItem").removeClass("active");
                                    scope.showPopover = false;
                                    scope.$apply();
                                    map.playTween(target);

                                });

                                kids.on("click", function (e) {
                                    var target = (angular.isUndefined(e.target.parent)) ?
                                        e.target : e.target.parent.attrs.index;
                                    $j(".listItem").removeClass("active");
                                    scope.showPopover = false;
                                    scope.$apply();
                                    map.playTween(target);
                                });

                                map.parentGroup.add(kids);
                            }

                            map.layer.add(map.parentGroup);
                            map.stage.add(map.layer);
                        },

                        apply: function () {
                            try {
                                scope.$apply();
                            } catch (e) { }
                        },

                        playTween: function (target) {
                            var groupName = "#group" + (target);
                            var shape = map.stage.find(groupName);

                            // using the text group for the x/y coords as the shape objects don't have those attrs.
                            var coordx = shape[0].children[1].attrs.x;
                            var coordy = shape[0].children[1].attrs.y;

                            scope.showPopover = false;

                            if (map.scale == 1) {
                                map.panZoom(target, coordx, coordy);
                            } else if (map.scale == 2 && scope.activeItem !== target) {
                                map.pan(target, coordx, coordy);
                            } else if (map.scale == 2 && scope.activeItem == target) {
                                map.scale = 1;
                                map.resetStage();
                            }
                        },

                        panZoom: function (el, x, y) {
                            var panZoomDef = {
                                node: map.parentGroup,
                                scaleX: 2,
                                scaleY: 2,
                                x: -x,
                                y: -y,
                                easing: Kinetic.Easings.EaseInOut,
                                duration: 0.6,
                                onFinish: function () {
                                    var loc = $j.grep(locations, function (e: any) { return e.id == el; });
                                    map.popover = buildPopover(loc[0], x, y, el);
                                    map.finishTween(2, el, true);
                                }
                            };
                            var anim = new Kinetic.Tween(panZoomDef);
                            anim.tween.play();
                        },

                        pan: function (el, x, y) {
                            var pan = {
                                node: map.parentGroup,
                                x: -x,
                                y: -y,
                                easing: Kinetic.Easings.EaseInOut,
                                duration: 0.6,
                                onFinish: function () {
                                    var loc = $j.grep(locations, function (e: any) { return e.id == el; });
                                    map.popover = buildPopover(loc[0], x, y, el);
                                    map.finishTween(2, el, true);
                                }
                            };
                            var anim = new Kinetic.Tween(pan);
                            anim.tween.play();
                        },

                        resetStage: function () {
                            var reset = {
                                node: map.parentGroup,
                                x: 0,
                                y: 0,
                                scaleX: 1,
                                scaleY: 1,
                                easing: Kinetic.Easings.EaseInOut,
                                duration: 0.6,
                                onFinish: function () {
                                    map.finishTween(1, null, false);
                                }
                            };
                            var anim = new Kinetic.Tween(reset);
                            anim.tween.play();
                        },

                        finishTween: function (scale, activeItem, showPopover) {
                            if (scale == 2) {
                                scope.zoomButton = true;
                                var img = map.stage.find(".smallMap");
                                img.fire('zoomIn');
                            } else {
                                scope.zoomButton = false;
                                var img = map.stage.find(".largeMap");
                                img.fire('zoomOut');
                            }
                            map.scale = scale;
                            map.activeItem = activeItem;
                            scope.popover = map.popover;
                            scope.showPopover = showPopover;

                            if (activeItem !== null) {
                                var item = $j.grep(locations, function (e: any) { return e.id == activeItem; });
                                setActiveTabItem(item[0]);
                                scrollList();
                            }
                            map.apply();
                        }
                    };

                    var lgImageObj = new Image();
                    lgImageObj.src = scope.resort.map_img;
                    var smImageObj = new Image();
                    smImageObj.src = lgImageObj.src;


                    smImageObj.onload = function () {
                        var step1, step2;
                        step1 = (3 / 4);
                        step2 = (2 / 3);
                        // var c1 = scaleImage(smImageObj, step1);
                        var c2 = scaleImage(smImageObj, step2);

                        map.initialize(c2);

                        // Listen for list-item click
                        $j(".listItem").on("click", function (e) {
                            if ($j(this).hasClass("active")) {
                                $j(this).toggleClass("active");
                                scope.showPopover = false;
                                map.resetStage();
                                scope.$apply();
                            } else {
                                $j(".listItem").removeClass("active");
                                scope.showPopover = false;
                                scope.$apply();
                                $j(this).addClass("active");
                                scrollList();
                                var id = $j(this).data("list-item");
                                map.playTween(id);
                            }
                        });

                        $rootScope.$on("closePopover", function () {
                            scope.showPopover = false;
                            scope.zoomButton = false;
                            $j(".listItem").removeClass("active");
                            map.fromListClick = false;
                            map.resetStage();
                        });

                        $rootScope.$on("resetStage", function () {
                            scope.showPopover = false;
                            map.fromListClick = false;
                            map.resetStage();
                        });
                    };
                }
            };
        }]) as any);
})(window, window['$j']);
}
